import { createAction, props } from '@ngrx/store';
import { Request } from './request.model';

export const addRequestList = createAction('[Request] Add Request List', props<{ requests: any[] }>());
export const fetchRequestList = createAction('[Request] Fetch Request List');
export const setCurrentRequest = createAction('[Request] Set Current Request', props<{ request: any }>());
export const getCurrentRequest = createAction('[Request] Get Current Request');
export const setLoggedInUser = createAction('set user',  props<{ request: any }>());
export const fetchLoggedInUser = createAction('get user');